import { render, staticRenderFns } from "./SabbaticalsTab.vue?vue&type=template&id=dcd650d4&"
import script from "./SabbaticalsTab.vue?vue&type=script&lang=js&"
export * from "./SabbaticalsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports